import ecran from "../../../../../core/injectors/ecran.injector";

export default ecran({
    source: "mr2005",
    ecrans: ["00-2"],
    params: ["id", "?ajoutIndividu"]
});
